<button (click)="close(false)" class="modal-close"></button>

<h4 class="modal-title" *ngIf="data.title">{{ data.title | lsTranslate }}</h4>

<div class="modal-content">
  <p class="modal-intro">
    {{ data.message | lsTranslate }}
  </p>
</div>

<div class="modal-footer">
  <button (click)="close(false)" class="o-button o-button--default">
    {{ data.cancel | lsTranslate }}
  </button>
  <button
    (click)="close(true)"
    [ngClass]="data.danger ? 'o-button--danger' : 'o-button--success'"
    class="o-button"
  >
    {{ data.confirm | lsTranslate }}
  </button>
</div>

<div ls-dynamic-translation id="No" i18n="Button|No Button @@buttonNo">No</div>
<div ls-dynamic-translation id="Yes" i18n="Button|Yes Button @@buttonYes">
  Yes
</div>
